
import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function ToolIndex() {
  return (
    <NonFSIndex
      data_type="tool"
      // save_all
    />
  );
}
